import { getPerfStateForCard } from './cardPerfSelectors';
import { useEffect, useState } from 'react';
import { useCardData } from '../CardDataContext';
import { Alert } from 'foundations-components/transitional/components/Alert';
import enviro from 'enviro';
import { isLegacyCard } from '../../utils/isLegacyCard';
import { useStore } from './LocationStateContext';
import { jsx as _jsx } from "react/jsx-runtime";
const TIMEOUT_MS = 1000;
export default function CardPerfHookWarningBanner() {
  const store = useStore();
  const {
    cardData,
    tabIndex
  } = useCardData();
  const [didNotCallPerfHooks, setDidNotCallPerfHooks] = useState(false);
  // Only run the checks if we are in local development
  const shouldRunChecks = !enviro.deployed();
  useEffect(() => {
    if (!shouldRunChecks) {
      return;
    }
    const timeoutId = setTimeout(() => {
      const cardPerfStoreState = store && store.getState();
      const cardState = getPerfStateForCard(cardPerfStoreState, isLegacyCard(cardData) ? cardData.configuration.cardType : cardData.definition.cardType, cardData.definition.cardId, tabIndex);

      // This should only render in local development (for now) and when the perfHooks haven't been called
      if (!(cardState !== null && cardState !== void 0 && cardState.perfHooksCalled)) {
        setDidNotCallPerfHooks(true);
        console.warn(`CardPerfHookWarningBanner: Card performance hooks were not called for the ${cardData.definition.cardType} card with id ${cardData.definition.cardId}.`, '\n',
        // eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils
        'If you are the card owner, please view the Performance Monitoring docs here: https://private.hubteamqa.com/trellis-crm-storybook/?path=/story/implementation-how-to-build-a-card--page', '\n', 'If you do not own this card and are seeing this warning in your app, reach out to the card owner to resolve this issue.', '\n', 'For additional help, reach out to the CRM Cards team in #crm-card-infra-frontend on Slack.');
      }
    }, TIMEOUT_MS);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [shouldRunChecks, cardData.definition.cardId, cardData.definition.cardType, store, cardData, tabIndex]);

  // if it is deployed (not local), then short-circuit and return null
  if (shouldRunChecks && didNotCallPerfHooks) {
    return /*#__PURE__*/_jsx(Alert, {
      titleText: "Missing Card Performance Hooks",
      type: "danger",
      children: "This card isn't rendering the required performance hooks. View the console log for more information."
    });
  }
  return null;
}